import { useState } from "react";
import { supabase } from "@/lib/supabase";
import { useTours } from "@/lib/siteData";
import { useAdminRows, isUuid, fmtDay, todaySP } from "@/lib/booking";
import { Card, Field, Select, SaveBtn, Ok, Err, SubTitle, useAction, smallBtn } from "./adminUI";

export default function DateBlocksAdmin() {
    const tours = useTours(true).filter((t) => isUuid(t.id));
    const rows = useAdminRows("date-blocks", (sb) => sb.from("date_blocks").select("*").gte("day", todaySP()).order("day"));
    const [f, setF] = useState({ day: "", tour_id: "", reason: "" });
    const { run, busy, msg, err } = useAction();
    const set = (k) => (v) => setF((o) => ({ ...o, [k]: v }));
    const names = Object.fromEntries(tours.map((t) => [t.id, t.title]));

    return (
        <Card className="space-y-4">
            <SubTitle>Bloquear dias</SubTitle>
            <div className="grid gap-4 sm:grid-cols-3" data-testid="date-blocks-admin">
                <Field label="Data" type="date" value={f.day} onChange={set("day")} testid="block-day" />
                <Select label="Aplicar a" value={f.tour_id} onChange={set("tour_id")} options={[["", "Todas as experiências"], ...tours.map((t) => [t.id, t.title])]} />
                <Field label="Motivo (interno)" value={f.reason} onChange={set("reason")} />
            </div>
            <div className="flex items-center justify-end gap-3"><Ok msg={msg} /><Err msg={err} />
                <SaveBtn saving={busy} testid="block-create" onClick={() => run(() => supabase.from("date_blocks").insert({ ...f, tour_id: f.tour_id || null }))}>Bloquear dia</SaveBtn></div>
            {(rows.data || []).map((r) => (
                <div key={r.id} className="flex items-center justify-between border-t border-ink/10 pt-3 text-sm">
                    <span>{fmtDay(r.day)} · {r.tour_id ? names[r.tour_id] : "Todas"} {r.reason && `· ${r.reason}`}</span>
                    <button className={smallBtn} onClick={() => run(() => supabase.from("date_blocks").delete().eq("id", r.id))}>Desbloquear</button>
                </div>
            ))}
        </Card>
    );
}
